import React, { useState, useEffect } from 'react';
import SectionHeader from '../../components/SectionHeader'
import { Col, Container, Row, Modal, Form } from 'react-bootstrap'
import axios from 'axios';
import { spt, states } from '../../data';
import { loadStripe } from '@stripe/stripe-js';
import { Link } from 'react-router-dom';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const Sports = () => {
    const [proEvents, setProEvents] = useState([]);
    const [eventQuery, setEventQuery] = useState('');
    const [stateQuery, setStateQuery] = useState('');
    const [dateQuery, setDateQuery] = useState('');
    const [maxAudience, setMaxAudience] = useState('');
    // const [show, setShow] = useState(false);
    // const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);
    // const [selectedOption, setSelectedOption] = useState("");

    const [checked, setChecked] = useState(false);
    const handleChange = () => setChecked(!checked);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                let baseUrl = process.env.REACT_APP_BASE_URL;
                const response = await axios.get(baseUrl + '/sports-event');
                setProEvents(response.data);
            } catch (error) {
                console.error('Error fetching Events:', error);
            }
        };
        fetchEvents();
    }, []);

    const handleCheckout = async (event) => {
        const stripe = await stripePromise;
        try {
            let baseUrl = process.env.REACT_APP_BASE_URL;
            const priceInCents = Math.round(parseFloat(event.rates) * 100);
            const response = await axios.post(baseUrl + '/create-checkout-session', {
                event_name: event.event_name,
                price: priceInCents,
            });
            const { sessionId } = response.data;
            const { error } = await stripe.redirectToCheckout({ sessionId });
            if (error) {
                console.error('Stripe Checkout Error:', error);
            }
        } catch (error) {
            console.error('Error creating checkout session:', error);
        }
    };

    const filteredEvents = proEvents.filter(event => {
        return (
            event.event_name === eventQuery &&
            // event.event_name.toLowerCase().includes(eventQuery.toLowerCase()) &&
            // event.state.toLowerCase().includes(stateQuery.toLowerCase())
            (!maxAudience || (event.min_audience <= maxAudience && maxAudience <= event.max_audience))
        );
    });


    return (
        <>
            <section>
                <SectionHeader title="Sports Events" PageLink="Sports page"></SectionHeader>
                <div className="in-page-container pt-5 pb-5">
                    <div className="about-section top__about">
                        <Container>
                            <div className="inner__form">
                                <Row>
                                    <Col md={6}>
                                        <label className="form-label" htmlFor="event">Enter or Select Event <span className='red_star'>*</span></label>
                                        <select id='event' name="event" className='form-control' value={eventQuery} onChange={(e) => setEventQuery(e.target.value)}>
                                            <option value="">Select Event</option>
                                            {spt.map((e, index) => (
                                                <option key={index} value={e.name}>{e.name}</option>
                                            ))}
                                        </select>
                                    </Col>
                                    <Col md={6}>
                                        <label className="form-label" htmlFor="state">Select State <span className='red_star'>*</span></label>
                                        <select id='state' name='state' className='form-control' value={stateQuery} onChange={(e) => setStateQuery(e.target.value)}>
                                            <option value="">Select State</option>
                                            {states.map((e, index) => (
                                                <option key={index} value={e.name}>{e.name}</option>
                                            ))}
                                        </select>
                                    </Col>
                                    <Col md={6} className='mt-5'>
                                        <label className="form-label" htmlFor="max_audience">Max Audience <span className='red_star'>*</span></label>
                                        <input type="text" id="max_audience" name='max_audience' className='form-control' value={maxAudience} onChange={(e) => setMaxAudience(parseInt(e.target.value.replace(/\D/g, "")))} />
                                    </Col>
                                    <Col md={6} className='mt-5'>
                                        <label className="form-label" htmlFor="event_date">Event Date <span className='red_star'>*</span></label>
                                        <input type="date" name='event_date' className='form-control' onChange={(e) => setDateQuery(e.target.value)} />
                                    </Col>
                                    <Col md={7}>
                                        <div className="events_footer_content sports__footer_content">
                                            <h5 className="d-flex">
                                                <Form.Check type="checkbox" id="default-checkbox" label="" checked={checked} onChange={handleChange} /><strong>Above products have below standard Exclusions</strong>
                                            </h5>
                                            <ul>
                                                <li>Alcohol Included for social - not for selling and making profits</li>
                                                <li>Considered you have <strong>"No claims above 5k in last three years"</strong> on any event insurance</li>
                                                <li>You have system for securing wavers for participants both adults and minors</li>
                                                <li>A matures only covered in the policy</li>
                                            </ul>
                                        </div>
                                    </Col>
                                    <Col md={4} className='mt-4'>
                                        <div className="phone_form vendor_phone_form">
                                            <p>Not Sure? <br /> Give us a call <br /> We'll Get You Covered Quickly!</p>
                                            <Link to="tel:(833) 320-1199">(833) 320-1199</Link>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="events__items">
                                <Row>
                                    {eventQuery && stateQuery && dateQuery && checked ? (
                                        filteredEvents.length > 0 ? (
                                            filteredEvents.map((event, index) => (
                                                <Col md={4} key={index}>
                                                    <div className="event__card">
                                                        <div className="offer_card">
                                                            <h3>{event.event_name}</h3>
                                                            <div className="pricing">
                                                                <span className="currency">$</span>
                                                                <span className="price">{event.rates}</span>
                                                            </div>
                                                            <hr />
                                                            <div className="offer_description">
                                                                <ul>
                                                                    <li>Max Audience : {event.max_audience}</li>
                                                                    <li>Each Occurrence : {event.each_occurrence}</li>
                                                                    <li>General Aggregate : {event.general_aggregate}</li>
                                                                    <li>Damage to rented Premises : {event.damage}</li>
                                                                    <li>products_comp : {event.products_comp}</li>
                                                                    <li>personal_injury : {event.personal_injury}</li>
                                                                    <li>medical_exp : {event.medical_exp}</li>
                                                                </ul>
                                                            </div>
                                                            <button type='button' className="custom_btn_1" onClick={() => handleCheckout(event)}>Get Policy</button>
                                                        </div>
                                                    </div>
                                                </Col>
                                            ))
                                        ) : (
                                            <p className='text-center mt-5'>
                                                There is no product for this combination, this would be a custom product , please reach us on <Link to="tel:(833) 320-1199">(833) 320-1199</Link>
                                            </p>
                                        )
                                    ) : null}
                                </Row>
                            </div>
                        </Container>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Sports